import { Field, SearchField } from 'components/commons';
import React, { useCallback } from 'react';
import styles from './account-filter.module.scss';

const AccountFilter = ({ filterState, onSearchChange, onSearch }) => {
  const onSearchChangeCb = useCallback(
    (name, { value }) => {
      if (onSearchChange) {
        return onSearchChange('searchKey', { value });
      }
    },
    [onSearchChange]
  );

  const onSearchCb = useCallback(
    (searchKey) => {
      if (onSearch) {
        return onSearch(searchKey);
      }
    },
    [onSearch]
  );

  return (
    <div className={styles.filter}>
      <Field className={styles.search}>
        <SearchField
          placeholder={'Code, Name'}
          value={filterState.searchKey}
          onChange={onSearchChangeCb}
          onEnter={onSearchCb}
          restrict={false}
        />
      </Field>
    </div>
  );
};

export default AccountFilter;
